// #region Imports
// imports of the vue components from DevExtreme
// the range-slider
import DxRangeSlider from 'devextreme-vue/range-slider';
// import the library from vue to create a custom component
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-filter-rangeslider',
    // #endregion
    // #region child components
    // include child components
    components: {
        // vue component Range Slider from DevExtreme
        DxRangeSlider
    },
    // #endregion
    // #region Properties
    props: {},
    // #endregion
    // #region data
    data: () => ({
        // data source for the range slider
        datasourceforrange: {
            // the label for the range slider as HTML element
            label: "Preis",
            // min value
            minvalue: 0,
            // max value
            maxvalue: 100,
            // step to increase/decrease the min and max value
            step: 1,
            // on which scope (article category) the range slider is referring to
            scope: "",
            dxformattype: "currency",
            // the unit for the datasource
            unit: "€"
        },
        // object whose property values are send to the database to get articles of a category (scope), whose price is in between the selected range
        selectedvaluesofrange: {
            // currently selected min value by the user
            min: 0,
            // currently selected max value by the user
            max: 100
        },
        // template object for a label of any DevExtreme Range Slider
        dxLabelTemplate: {},
        // template object for a tooltip of any DevExtreme Range Slider
        dxTooltipTemplate: {}
    }),
    // #endregion
    // #region Constructor
    created() {
    },
    // #endregion
    // #region Watch
    watch: {},
    // #endregion
    // #region Computed
    computed: {},
    // #endregion
    // #region Core
    methods: {
        // function to override the label object as template, declared in the data property
        createDxLabel() {
            this.dxLabelTemplate = {
                visible: true,
                format: {
                    /* the type of the unit, used for the DevExtreme vue component (price, height, etc.)
                    Accepted Values: 'billions' | 'currency' | 'day' | 'decimal' | 'exponential'
                    | 'fixedPoint' | 'largeNumber' | 'longDate' | 'longTime' | 'millions' | 'millisecond'
                    | 'month' | 'monthAndDay' | 'monthAndYear' | 'percent' | 'quarter' | 'quarterAndYear'
                    | 'shortDate' | 'shortTime' | 'thousands' | 'trillions' | 'year' | 'dayOfWeek' | 'hour'
                    | 'longDateLongTime' | 'minute' | 'second' | 'shortDateShortTime' */
                    type: "currency",
                    /* a specific 3-letter code for the "currency" format, in this Case set the currency to Euro,
                     * without it, the type uses the default currency dollar */
                    currency: "EUR"
                },
                position: 'top'
            };
            // return the label as object
            return this.dxLabelTemplate;
        },
        // function to override the tooltip object as template, declared in the data property
        createDxTooltip() {
            this.dxTooltipTemplate = {
                enabled: true,
                // set the currency to EURO
                format: {
                    // same accepted values as in format object above
                    type: "currency",
                    currency: "EUR"
                },
                // always display the min and max value, default mode is 'onHover'
                showMode: 'always',
                // display the selected min and max value below the Range Slider controls
                position: 'bottom'
            };
            // return the tooltip as object
            return this.dxTooltipTemplate;
        }
    }
    // #endregion
});
// #endregion
